<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>

<script>
export default {
    name: "App",
    created(){
        
    }
};
</script>

<style lang="scss" scoped>
#app {
    height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue